import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions, actionTypes} from "../redux/actions";
// import {ME_URL, GET_CAPTCHA_URL} from "../../../api/authApi";
import httpClientService from "../../../helpers/apiHelper";
import Config from "../../../helpers/Config";


function* loadingCaptcha() {
  const domin = Config.get("API_HOST");
  console.log("loadingCaptcha: ");
  const {data} = yield call(httpClientService,'get',`${domin}/captcha/login` ,'tmp', {} );
  yield put(actions.loadCaptchaImageSuccess(data));
}

export function* watchLoadingCaptcha() {
  yield takeEvery(actionTypes.loadCaptchaImage, loadingCaptcha);
}

// function* loginSaga() {
//   yield put(actions.requestUser());
// }

// export function* watchLoginSaga() {
//   yield takeLatest(actionTypes.Login, loginSaga);
// }

// 監聽登入失敗
export function* watchLoginError() {
  yield takeEvery(actionTypes.LoginError, loginFail);
}
// 登入失敗
export function* loginFail() {
  // console.log("loginFail: ", actions.loginError());
  yield put(actions.loginErrorDone());
}

// 請求User資料
function* userRequested(data) {
  const domin = Config.get("API_HOST");
  // 真正打Api出去要求User資料
  const authToken = data.paload.authToken;
  console.log('authToken = ', authToken)
  const { data: user } = yield httpClientService('get',`${domin}/vendor/account`,authToken,{});
  console.log('user = ', user)
  // if(user){
    // 資料庫有此帳號資料
    yield put(actions.fulfillUser(user));
  // }
  // else{
  //   // 資料庫搜尋不到此帳號資料
  // }
}

export function* watchUserRequested() {
  yield takeLatest(actionTypes.UserRequested, userRequested);
}

function* registerSaga() {
  // console.log("registerSaga: ", actions.requestUser());
  yield put(actions.requestUser());
}

export function* watchRegisterSaga() {
  yield takeLatest(actionTypes.Register, registerSaga);
}

